
import React from "react";


import './MahutiStepper.css'
import { isMobile } from "react-device-detect";
import { useSelector } from "react-redux";


export function MahutiStepper(props) {

    const store = useSelector(state => state.reducer);
    const dateFlowType = store.flowType === "DATE_FLOW";
    //const isCurrentTitle = props.steps.find(item => item.isCurrent)?.title

    return  <div className="mahutiStepper row justify-content-center">
                {!dateFlowType && <div className="col-lg-1 col d-none d-lg-block"></div>}
                    {store.steps?.map((item, index) =>
                        <div key={'li.mahutiSteppemahutiStepper__item.' + index}
                            className={`mahutiStepper__item ${dateFlowType ? 'col-3 pe-0' : 'col-4'} col-lg-3 ` + (item.isCurrent ? 'current' : '') + ' ' + item.name}>
                            {item.status === 'done' ? <div className="md-step-circle "></div> :
                                <div className="md-step-circle"><span className="text-mahuti ">{index + 1}</span></div>
                            }
                            <div className="mahutiStepper_arrow col d-flex p-1">  
                                <span className="mahutiStepper__title text-mahuti">{item.title} </span>
                            </div>
                                {index < props.steps.length - 1 ?
                                <i className={`chevron-left icon ${isMobile ? '' : 'col'}`}/>
                                    : <span className="col"></span>
                                }
                        </div>
                    )}
                {!dateFlowType && <div className="col-lg-1 col d-none d-lg-block"></div>}
            </div>


}